import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Card from "@material-ui/core/Card";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import HiddenOn from "components/common/HiddenOn";

export const UpdatePassword = ({ userData, changePwd, error, message }) => {
  const [values, setValues] = useState({
    newPassword: "",
    newConfirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleChange = (prop) => {
    //this is technically abusing state, but I don't care at this point
    //this took way too long to get working
    prop.forEach((item) => {
      const key = Object.entries(item)[0][0];
      const value = Object.entries(item)[0][1];
      values[`${key}`] = value;
    });
    setValues({ ...values });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = () => {
    const { newPassword, newConfirmPassword } = values;
    changePwd({ newPassword, newConfirmPassword, userData });
  };

  return (
    <StyledCard>
      <div>
        Please enter your new password:
        <div id={"newPassword"}>
          <InputLabel htmlFor="standard-adornment-password">
            Password
          </InputLabel>
          <Input
            id="standard-adornment-password"
            type={values.showPassword ? "text" : "password"}
            value={values.newPassword}
            onChange={(i) => {
              handleChange([{ newPassword: i.target.value }]);
            }}
            onKeyPress={(event) => {
              if (event.which === 13) {
                handleSubmit();
                event.preventDefault();
              }
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={(i) => {
                    handleChange([{ showPassword: !values.showPassword }]);
                  }}
                  onMouseDown={handleMouseDownPassword}
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        <div id={"confirmNewPassword"}>
          <InputLabel htmlFor="standard-adornment-confirm-password">
            Confirm Password
          </InputLabel>
          <Input
            id="standard-adornment-confirm-password"
            type={values.showConfirmPassword ? "text" : "password"}
            value={values.newConfirmPassword}
            onChange={(i) => {
              handleChange([{ newConfirmPassword: i.target.value }]);
            }}
            onKeyPress={(event) => {
              if (event.which === 13) {
                handleSubmit();
                event.preventDefault();
              }
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle confirm password visibility"
                  onClick={() => {
                    handleChange([
                      { showConfirmPassword: !values.showConfirmPassword },
                    ]);
                  }}
                  onMouseDown={handleMouseDownPassword}
                >
                  {values.showConfirmPassword ? (
                    <Visibility />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        <Button color={"primary"} onClick={handleSubmit}>
          Update Password
        </Button>
        <HiddenOn hideOn={!error}>
          <StyledError>{message}</StyledError>
        </HiddenOn>
      </div>
      <p>
        Password requirements:
        <br />
        <br />- Must be at least 6 characters.
        <br />- Must contain at least one uppercase letter.
        <br />- Must contain at least one lowercase letter.
        <br />- Must contain at least one number.
        <br />- Must contain one character from the following set:
        <br /> = + - ^ $ * . [ ] &#123; &#125; ( ) ? " ! @ # % &amp; / \ , &lt;
        &gt; &#39; : ; | _ ~ `
      </p>
    </StyledCard>
  );
};

const StyledError = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 10px;
  max-width: inherit;
`;

const StyledCard = styled(Card)`
  display: flex;
  align-self: center;
  padding: 30px;

  > p {
    margin-top: 0px;
  }
  > div {
    width: 400px;
  }

  #newPassword,
  #confirmNewPassword {
    padding: 10px;
  }
`;

export default UpdatePassword;
